import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { el: to.hash, behavior: 'smooth' }
    return { top: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./pages/HomePage.vue'),
      meta: { title: 'U.S. to Jamaica freight' },
    },
    {
      path: '/ship',
      name: 'ship',
      component: () => import('./pages/ShipPage.vue'),
      meta: { title: 'Ship and estimate' },
    },
    {
      path: '/track',
      name: 'track',
      component: () => import('./pages/TrackPage.vue'),
      meta: { title: 'Track a package' },
    },
    {
      path: '/quote',
      name: 'quote',
      component: () => import('./pages/QuotePage.vue'),
      meta: { title: 'Request a quote' },
    },
    {
      path: '/locations',
      name: 'locations',
      component: () => import('./pages/LocationsPage.vue'),
      meta: { title: 'Locations' },
    },
    {
      path: '/rewards',
      name: 'rewards',
      component: () => import('./pages/RewardsPage.vue'),
      meta: { title: 'Rewards' },
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('./pages/ContactPage.vue'),
      meta: { title: 'Contact us' },
    },
    {
      path: '/help',
      name: 'help',
      component: () => import('./pages/HelpPage.vue'),
      meta: { title: 'Help and FAQs' },
    },
    {
      path: '/help/:slug',
      name: 'faq-detail',
      component: () => import('./pages/FaqDetailPage.vue'),
      meta: { title: 'Help answer' },
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('./pages/LegalPage.vue'),
      props: { documentType: 'privacy-policy' },
      meta: { title: 'Privacy policy' },
    },
    {
      path: '/terms',
      name: 'terms',
      component: () => import('./pages/LegalPage.vue'),
      props: { documentType: 'terms-of-service' },
      meta: { title: 'Terms of service' },
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('./pages/NotFoundPage.vue'),
      meta: { title: 'Page not found' },
    },
  ],
})

router.afterEach((to) => {
  const title = typeof to.meta.title === 'string' ? to.meta.title : 'Freight logistics'
  document.title = `${title} — Carib Wave Logistics`
})

export default router
